import _objectSpread from "/Users/aaron/projects/ual-anchor-demo/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _possibleConstructorReturn from "/Users/aaron/projects/ual-anchor-demo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/aaron/projects/ual-anchor-demo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/aaron/projects/ual-anchor-demo/node_modules/@babel/runtime/helpers/esm/inherits";
import _regeneratorRuntime from "/Users/aaron/projects/ual-anchor-demo/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/Users/aaron/projects/ual-anchor-demo/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/Users/aaron/projects/ual-anchor-demo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/aaron/projects/ual-anchor-demo/node_modules/@babel/runtime/helpers/esm/createClass";
import { SessionError } from './errors';
import { abiEncode, sealMessage } from './utils';
/**
 * Type describing a link session that can create a eosjs compatible
 * signature provider and transact for a specific auth.
 */

export var LinkSession =
/*#__PURE__*/
function () {
  function LinkSession() {
    _classCallCheck(this, LinkSession);
  }

  _createClass(LinkSession, [{
    key: "remove",

    /**
     * Convenience, remove this session from associated [[Link]] storage if set.
     * Equivalent to:
     * ```ts
     * session.link.removeSession(session.identifier, session.auth)
     * ```
     */
    value: function () {
      var _remove = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!this.link.storage) {
                  _context.next = 3;
                  break;
                }

                _context.next = 3;
                return this.link.removeSession(this.identifier, this.auth);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function remove() {
        return _remove.apply(this, arguments);
      }

      return remove;
    }()
    /** Restore a previously serialized session. */

  }], [{
    key: "restore",
    value: function restore(link, data) {
      switch (data.type) {
        case 'channel':
          return new LinkChannelSession(link, data.data, data.metadata);

        case 'fallback':
          return new LinkFallbackSession(link, data.data, data.metadata);

        default:
          throw new Error('Unable to restore, session data invalid');
      }
    }
  }]);

  return LinkSession;
}();
/**
 * Link session that pushes requests over a channel.
 * @internal
 */

export var LinkChannelSession =
/*#__PURE__*/
function (_LinkSession) {
  _inherits(LinkChannelSession, _LinkSession);

  function LinkChannelSession(link, data, metadata) {
    var _this;

    _classCallCheck(this, LinkChannelSession);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(LinkChannelSession).call(this));
    _this.type = 'channel';
    _this.timeout = 2 * 60 * 1000; // ms

    _this.link = link;
    _this.auth = data.auth;
    _this.publicKey = data.publicKey;
    _this.channel = data.channel;
    _this.identifier = data.identifier;

    _this.encrypt = function (request) {
      return sealMessage(request.encode(true, false), data.requestKey, data.channel.key);
    };

    _this.metadata = _objectSpread({}, metadata || {}, {
      timeout: _this.timeout,
      name: _this.channel.name
    });

    _this.serialize = function () {
      return {
        type: 'channel',
        data: data,
        metadata: _this.metadata
      };
    };

    return _this;
  }

  _createClass(LinkChannelSession, [{
    key: "onSuccess",
    value: function onSuccess(request, result) {
      if (this.link.transport.onSuccess) {
        this.link.transport.onSuccess(request, result);
      }
    }
  }, {
    key: "onFailure",
    value: function onFailure(request, error) {
      if (this.link.transport.onFailure) {
        this.link.transport.onFailure(request, error);
      }
    }
  }, {
    key: "onRequest",
    value: function onRequest(request, cancel) {
      var info = {
        expiration: new Date(Date.now() + this.timeout).toISOString().slice(0, -1)
      };

      if (this.link.transport.onSessionRequest) {
        this.link.transport.onSessionRequest(this, request, cancel);
      }

      setTimeout(function () {
        cancel(new SessionError('Wallet did not respond in time', 'E_TIMEOUT'));
      }, this.timeout + 500);
      request.data.info.push({
        key: 'link',
        value: abiEncode(info, 'link_info')
      });
      this.link.rpc.fetchBuiltin(this.channel.url, {
        method: 'POST',
        headers: {
          'X-Buoy-Wait': (this.timeout / 1000).toFixed(0)
        },
        body: this.encrypt(request)
      }).then(function (response) {
        if (response.status !== 200) {
          cancel(new SessionError('Unable to push message', 'E_DELIVERY'));
        } else {// request delivered
        }
      }).catch(function (error) {
        cancel(new SessionError("Unable to reach link service (".concat(error.message || String(error), ")"), 'E_DELIVERY'));
      });
    }
  }, {
    key: "makeSignatureProvider",
    value: function makeSignatureProvider() {
      return this.link.makeSignatureProvider([this.publicKey], this);
    }
  }, {
    key: "makeAuthorityProvider",
    value: function makeAuthorityProvider() {
      return this.link.makeAuthorityProvider();
    }
  }, {
    key: "transact",
    value: function transact(tx, options) {
      return this.link.transact(tx, options, this);
    }
  }]);

  return LinkChannelSession;
}(LinkSession);
/**
 * Link session that sends every request over the transport.
 * @internal
 */

export var LinkFallbackSession =
/*#__PURE__*/
function (_LinkSession2) {
  _inherits(LinkFallbackSession, _LinkSession2);

  function LinkFallbackSession(link, data, metadata) {
    var _this2;

    _classCallCheck(this, LinkFallbackSession);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(LinkFallbackSession).call(this));
    _this2.type = 'fallback';
    _this2.link = link;
    _this2.auth = data.auth;
    _this2.publicKey = data.publicKey;
    _this2.metadata = metadata || {};
    _this2.identifier = data.identifier;

    _this2.serialize = function () {
      return {
        type: _this2.type,
        data: data,
        metadata: _this2.metadata
      };
    };

    return _this2;
  }

  _createClass(LinkFallbackSession, [{
    key: "onSuccess",
    value: function onSuccess(request, result) {
      if (this.link.transport.onSuccess) {
        this.link.transport.onSuccess(request, result);
      }
    }
  }, {
    key: "onFailure",
    value: function onFailure(request, error) {
      if (this.link.transport.onFailure) {
        this.link.transport.onFailure(request, error);
      }
    }
  }, {
    key: "onRequest",
    value: function onRequest(request, cancel) {
      if (this.link.transport.onSessionRequest) {
        this.link.transport.onSessionRequest(this, request, cancel);
      } else {
        this.link.transport.onRequest(request, cancel);
      }
    }
  }, {
    key: "makeSignatureProvider",
    value: function makeSignatureProvider() {
      return this.link.makeSignatureProvider([this.publicKey], this);
    }
  }, {
    key: "makeAuthorityProvider",
    value: function makeAuthorityProvider() {
      return this.link.makeAuthorityProvider();
    }
  }, {
    key: "transact",
    value: function transact(tx, options) {
      return this.link.transact(tx, options, this);
    }
  }]);

  return LinkFallbackSession;
}(LinkSession);